const requireLang = require.context('./', false, /\.js$/);
const langFiles = requireLang.keys().map((file) => file.replace('./', '').replace('.js', ''));

export default langFiles;